/**
 * Parse a date string in DD/MM/YYYY or YYYY-MM-DD format
 */
function parseFlexibleDate(dateStr: string): Date | null {
  if (!dateStr) return null;

  // Try DD/MM/YYYY format (common in UK)
  const ddmmyyyMatch = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (ddmmyyyMatch) {
    const [, day, month, year] = ddmmyyyMatch;
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }

  // Try YYYY-MM-DD format (ISO)
  const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }

  // Fallback: try native Date parsing
  const d = new Date(dateStr);
  return isNaN(d.getTime()) ? null : d;
}

/**
 * Calculate age in years from date of birth
 */
export function calculateAgeYearsFromDateOfBirth(
  dateOfBirth: unknown
): number | null {
  if (!dateOfBirth) return null;

  let dob: Date | null = null;
  if (typeof dateOfBirth === "string") {
    dob = parseFlexibleDate(dateOfBirth);
  } else if (dateOfBirth instanceof Date) {
    dob = dateOfBirth;
  } else {
    return null;
  }

  if (!dob || isNaN(dob.getTime())) return null;

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < dob.getDate())
  ) {
    age--;
  }

  return age >= 0 ? age : null;
}
